<script lang="ts" setup>
import { onMounted, computed } from 'vue'
import Breadcrumb from './Breadcrumb.vue'
import { useRoute } from 'vue-router'
import { useTabsViewStore } from '@/store/modules/tabs'
import { useMicroAppConfigStore } from '@/store/modules/microAppConfig'
import useMenu from '@/hooks/useMenu'
import { initMicroApps } from '@/utils/micro-app'

defineProps<{ hideHeader: boolean }>()

const menuStore = useMenu()
const isRouteInited = computed(menuStore.isRouteInited)

const tabsViewStore = useTabsViewStore()
const microAppConfig = useMicroAppConfigStore()
const cacheTabs = computed(() => {
  return tabsViewStore.getCacheTabs || []
})

const showMicroApp = computed(() => {
  return microAppConfig.showMicroApp
})

// 需要获取该dom用于挂载子应用，因此mounted之后再注册子应用，确保挂载成功
// 在 container 已挂载后注册并启动微应用，保证先 register 再 start，且不挂到根节点
onMounted(() => {
  initMicroApps()
})

const route = useRoute()
const isMobilePage = computed(() => route.meta.isMobilePage)
</script>

<template>
  <ALayoutContent class="flex flex-col">
    <Breadcrumb v-if="!hideHeader" />
    <div class="content page-scroll overflow-y-auto" :class="{ 'mobile-page': isMobilePage }">
      <!-- 路由初始化完成后渲染 -->
      <template v-if="isRouteInited">
        <RouterView v-slot="{ Component, route }">
          <KeepAlive :include="cacheTabs">
            <Component :is="Component" :key="route.fullPath" />
          </KeepAlive>
        </RouterView>
      </template>
      <div v-show="showMicroApp" id="micro-app-container" />
    </div>
  </ALayoutContent>
</template>

<style lang="scss" scoped>
@import '@/styles/var/colors.scss';
.content {
  min-height: calc(100vh - 68px - 56px);
  position: relative;
  flex: 1 1 auto;
  background-color: #f2f3f5;
  padding: 0 24px 24px 24px;

  &.mobile-page {
    padding: 0;
  }
}
#micro-app-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
.ant-layout-content :deep(.content) {
  background-color: $bgPrimary;
}
</style>
